import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "as", "className"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_ITEM_CLASS_NAME } from './ContinuousScrollItem.constants';
import { classNames } from '../../../../../../utils/classname';
import { createComponent } from '../../../../../foundation/services/components';
import { ChildrenPropType, ComponentPropType } from '../../../../../foundation/types/component';
var propTypes = {
  children: ChildrenPropType.isRequired,
  as: ComponentPropType,
  className: PropTypes.string
};
var defaultProps = {
  as: 'div',
  className: ''
};
export default function ContinuousScrollItem(_ref) {
  var _classNames;
  var children = _ref.children,
    as = _ref.as,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var finalClassName = classNames((_classNames = {}, _defineProperty(_classNames, DEFAULT_ITEM_CLASS_NAME, true), _defineProperty(_classNames, className, true), _classNames));
  return createComponent(as, _objectSpread(_objectSpread({}, rest), {}, {
    children: children,
    className: finalClassName
  }));
}
ContinuousScrollItem.propTypes = propTypes;
ContinuousScrollItem.defaultProps = defaultProps;